<template>
  <div class="ma-0 pa-0">
    <div
      v-if="!$apollo.loading"
      :class="printOrientation === 'LANDSCAPE' ? 'print-mode-landscape' : 'print-mode-portrait'"
      class="ma-0 pa-0"
    >
      <template v-for="(attendeePage, pageIndex) in attendeePages">
        <div :key="`front-${pageIndex}`" class="print-sheet">
          <div v-for="attendee in attendeePage" :key="attendee.id" class="preview-container ma-0 pa-0">
            <preview
              :background-image-url="backgroundImageURL"
              :items="items"
              :accreditation="attendee"
              :width="width"
              :height="height"
              :attendee-fields="attendeeFields"
            />
          </div>
        </div>
        <div v-if="hasBackSide" :key="`back-${pageIndex}`" class="print-sheet">
          <div v-for="attendee in attendeePage" :key="attendee.id" class="preview-container ma-0 pa-0">
            <preview
              :background-image-url="backBackgroundImageURL"
              :items="backItems"
              :accreditation="attendee"
              :width="width"
              :height="height"
              :attendee-fields="attendeeFields"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Preview from './preview.vue'
import { GET_BULK_PRINT_DATA } from './../../graphql/event.graphql'
import { formats, mmToPixel, changeOrientation } from './builder.utils'
import { objectToArray } from './../../utils'

export default {
  components: {
    Preview,
  },
  props: {
    accreditationIds: [Array, String],
    eventId: String,
  },
  data() {
    return {
      attendees: [],
      printOrientation: '',
      items: [],
      width: -1,
      height: -1,
      backgroundImageURL: '',
      backBackgroundImageURL: '',
      backItems: [],
      hasBackSide: false,
      formatName: '',
    }
  },
  computed: {
    attendeePages() {
      const attendeesPerPage = this.formatName === 'BC1' ? 10 : 4
      const pages = []
      for (let index = 0; index < this.attendees.length; index += attendeesPerPage) {
        pages.push(this.attendees.slice(index, index + attendeesPerPage))
      }

      return pages
    },
  },
  apollo: {
    getEvent: {
      query: GET_BULK_PRINT_DATA,
      variables() {
        let attendeeIds
        if (this.accreditationIds === 'all') {
          attendeeIds = []
        } else {
          attendeeIds =
            typeof this.accreditationIds === 'string'
              ? [this.accreditationIds]
              : this.accreditationIds
        }

        return {
          eventId: this.eventId,
          attendeeIds,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const { getEvent: event, getAccreditations: attendees } = data
          if (event.builder) {
            const {
              orientation,
              backgroundImage,
              items,
              backBackgroundImage,
              backItems,
              hasBackSide,
            } = event.builder
            this.backgroundImageURL = backgroundImage
            this.items = items || []
            this.backBackgroundImageURL = backBackgroundImage
            this.backItems = backItems || []
            this.hasBackSide = Boolean(hasBackSide)
            const format = formats.find(f => event.builder.format === f.name)
            const { name, width, height, defaultOrientation, defaultPrintOrientation } = format
            const orientationChanged = orientation !== defaultOrientation
            this.formatName = name
            this.width = mmToPixel(!orientationChanged ? width : height)
            this.height = mmToPixel(!orientationChanged ? height : width)
            this.printOrientation = !orientationChanged
              ? defaultPrintOrientation
              : changeOrientation(defaultPrintOrientation)
          }
          this.attendees = attendees
          this.attendeeFields = objectToArray(event.attendeeFields, 'name')
        }
      },
    },
  },
}
</script>

<style scoped>
.print-mode-landscape {
  height: 210mm;
  width: 297mm;
}

.print-mode-portrait {
  height: 297mm;
  width: 210mm;
}

.print-sheet {
  page-break-after: always;
  clear: both;
}

.preview-container {
  float: left;
}

.break-page {
  page-break-before: always;
  height: 0;
  display: block;
  clear: both;
}
</style>
